import type {
  FavoriteResponse,
  LikeResponse,
  ToggleAction,
} from "api-contract/article-engagement";
import { request } from "./request";

export type {
  FavoriteResponse,
  LikeResponse,
} from "api-contract/article-engagement";

/** 获取当前语言前缀 */
function getLangPrefix(): string {
  return (window as any).__LANG_PREFIX__ || "/zh";
}

/**
 * 发送文章点赞请求
 */
export async function like(
  articleId: number,
  action?: ToggleAction,
): Promise<LikeResponse> {
  return request<LikeResponse>(
    `${getLangPrefix()}/web/articles/${articleId}/like`,
    {
      method: "POST",
      body: JSON.stringify({ action }),
    },
  );
}

/**
 * 发送文章收藏请求
 */
export async function favorite(
  articleId: number,
  action?: ToggleAction,
): Promise<FavoriteResponse> {
  return request<FavoriteResponse>(
    `${getLangPrefix()}/web/articles/${articleId}/favorite`,
    {
      method: "POST",
      body: JSON.stringify({ action }),
    },
  );
}
